/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import get from 'lodash/get.js';
import InfoIcon from '../../common/icons/InfoIcon';
import DictionaryModal from '../WhatIsThisDictionaryTermModal';
import dictionaryDefinitionApi from '../../api/dictionaryDefinitionApi';
import { DictionaryWrapper, MeasureButton } from './styles';

import { getConfig } from '../../config';
import { sizes } from '../../utils/style-utils';

const CustomDictionaryWrapper = styled(DictionaryWrapper)`

  .details-link {
    display: inline;
  }

  @media (max-width: ${sizes.mobile}px) {
    .details-link {
      display: block;
      margin-left: -1rem;
      margin-top: -1rem;
      margin-bottom: 2rem;
    }
  }
`;
const WhatIsThisDictionaryTermLink = (props) => {
  const [open, setOpen] = useState(false);
  const [dictionaryTerm, setDictionaryTerm] = useState();
  const { term, header } = props;
  const escFunction = (event) => {
    if (event.keyCode === 27) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);
    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, []);

  const handleOpen = (event) => {
    event.stopPropagation();
    const dictionaryDefinitionApiUrl = `${get(getConfig(), 'eleanorBaseUrl')}/${get(getConfig(), 'loadDictionaryDefinitionApi')}`;
    const productLineId = get(getConfig(), 'productLineId');
    if (!dictionaryTerm) {
      dictionaryDefinitionApi(dictionaryDefinitionApiUrl, term, productLineId)
        .then((response) => {
          setDictionaryTerm({ mediaUrl: response.data.mediaUrl, ...response.data.definition });
        }).then(() => {
          setOpen(true);
        });
    } else {
      setOpen(true);
    }
  };

  const handleClose = (event) => {
    event.stopPropagation();
    setOpen(false);
  };

  return (
    <CustomDictionaryWrapper>
      <MeasureButton
        onClick={(event) => handleOpen(event)}
      >
        <span className="measurement-info-icon sui-pr-2"><InfoIcon /></span>
        <span className="sui-underline">See details</span>
      </MeasureButton>
      {open
        && dictionaryTerm && (
        <DictionaryModal
          term={term}
          open={open}
          definition={dictionaryTerm.Definition}
          mediaUrl={dictionaryTerm.mediaUrl}
          videoId={dictionaryTerm.LiveClickerVideoTag}
          handleClose={(event) => handleClose(event)}
          header={header}
        />
      )}
    </CustomDictionaryWrapper>
  );
};

WhatIsThisDictionaryTermLink.propTypes = {
  term: PropTypes.string.isRequired,
  header: PropTypes.string,
};

WhatIsThisDictionaryTermLink.defaultProps = {
  header: PropTypes.string,
};

export default WhatIsThisDictionaryTermLink;
